import { api } from "./api";
import type { BulkSyncResult } from "@/types/bulkSync";
import type {
  FeedLog,
  EggProduction,
  MortalityLog,
} from "@/types/models";

interface PaginatedResponse<T> {
  data: T[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const feedLogService = {
  list: (params?: Record<string, string | number>) =>
    api.get<PaginatedResponse<FeedLog>>("/feed-logs", { params }).then((r) => r.data),
  get: (id: number) =>
    api.get<FeedLog>(`/feed-logs/${id}`).then((r) => r.data),
  create: (data: Partial<FeedLog>) =>
    api.post<FeedLog>("/feed-logs", data).then((r) => r.data),
  update: (id: number, data: Partial<FeedLog>) =>
    api.put<FeedLog>(`/feed-logs/${id}`, data).then((r) => r.data),
  delete: (id: number) =>
    api.delete(`/feed-logs/${id}`).then((r) => r.data),
  bulkCreate: (data: Partial<FeedLog>[]) =>
    api.post<BulkSyncResult<FeedLog>>("/feed-logs/bulk", data).then((r) => r.data),
};

export const eggProductionService = {
  list: (params?: Record<string, string | number>) =>
    api.get<PaginatedResponse<EggProduction>>("/egg-production", { params }).then((r) => r.data),
  get: (id: number) =>
    api.get<EggProduction>(`/egg-production/${id}`).then((r) => r.data),
  create: (data: Partial<EggProduction>) =>
    api.post<EggProduction>("/egg-production", data).then((r) => r.data),
  update: (id: number, data: Partial<EggProduction>) =>
    api.put<EggProduction>(`/egg-production/${id}`, data).then((r) => r.data),
  delete: (id: number) =>
    api.delete(`/egg-production/${id}`).then((r) => r.data),
  checkExisting: (flockId: number, date: string) =>
    api.get<{ exists: boolean; record?: EggProduction }>("/egg-production/check-existing", {
      params: { flock_id: flockId, date },
    }).then((r) => r.data),
  bulkCreate: (data: Partial<EggProduction>[]) =>
    api.post<BulkSyncResult<EggProduction>>("/egg-production/bulk", data).then((r) => r.data),
};

export const mortalityLogService = {
  list: (params?: Record<string, string | number>) =>
    api.get<PaginatedResponse<MortalityLog>>("/mortality", { params }).then((r) => r.data),
  get: (id: number) =>
    api.get<MortalityLog>(`/mortality/${id}`).then((r) => r.data),
  create: (data: Partial<MortalityLog>) =>
    api.post<MortalityLog>("/mortality", data).then((r) => r.data),
  update: (id: number, data: Partial<MortalityLog>) =>
    api.put<MortalityLog>(`/mortality/${id}`, data).then((r) => r.data),
  delete: (id: number) =>
    api.delete(`/mortality/${id}`).then((r) => r.data),
  bulkCreate: (data: Partial<MortalityLog>[]) =>
    api.post<BulkSyncResult<MortalityLog>>("/mortality/bulk", data).then((r) => r.data),
};
